import { styled } from "@mui/material";
import BasicAccordion from "../../Accordion/Accordion";
import { dashboardText } from "pages/AgronomistDashboard/_utils/shared";

const BasicAccordionStyled = styled(BasicAccordion)({
  "&&.accordion": {
    width: "100%",
    boxShadow: "none",
    margin: 0,
    "& .accordion-summary": {
      padding: 0,
      "& .accordion-title": {
        fontSize: "16px",
        fontWeight: 500,
        color: "#242424",
      },
    },
    "& .accordion-details": {
      padding: 0,
      paddingBottom: "16px",
    },
  },
});

const BasicAccordionStyledNewVersion = styled(BasicAccordion)({
  "&&.accordion": {
    width: "100%",
    boxShadow: "none",
    margin: 0,
    "& .accordion-summary": {
      padding: 0,
      "& .accordion-title": {
        ...dashboardText,
        fontWeight: 500,
        color: "#5f6f78",
      },
    },
    "& .accordion-details": {
      padding: 0,
      paddingBottom: "16px",
    },
  },
});

const DetailSection = ({ children, title, isRequired, isNewVersion }) => {
  const finalTitle = isRequired ? title + " *" : title;
  return isNewVersion ? (
    <BasicAccordionStyledNewVersion
      expandPosition="start"
      title={finalTitle}
      isInitiallyOpen
      className="accordion"
      classNames={{
        summary: "accordion-summary",
        details: "accordion-details",
        title: "accordion-title",
      }}
    >
      {children}
    </BasicAccordionStyledNewVersion>
  ) : (
    <BasicAccordionStyled
      expandPosition="start"
      title={finalTitle}
      isInitiallyOpen
      className="accordion"
      classNames={{
        summary: "accordion-summary",
        details: "accordion-details",
        title: "accordion-title",
      }}
    >
      {children}
    </BasicAccordionStyled>
  );
};

export default DetailSection;
